import { combineEpics } from 'redux-observable';
import { fetchWatchesEpic } from './Watch/FetchWatchesEpic';
import { fetchWatchBySlugEpic } from './Watch/FetchWatchBySlugEpic';
import { reserveWatchesEpic } from './Checkout/ReserveWatchesEpic';
import { fetchShippingZonesEpic } from './Checkout/FetchShippingZonesEpic';
import { createOrderEpic } from './Checkout/CreateOrderEpic';

export const rootEpic = combineEpics(
  fetchWatchesEpic,
  fetchWatchBySlugEpic,
  reserveWatchesEpic,
  fetchShippingZonesEpic,
  createOrderEpic
);
